// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ProductTypeConfig } from './product-type-config';
import { ProgramView } from './program-view';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramViewProductTypeConfig extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key FK programView */
  programViewId!: string;
  /** Guid key FK productTypeConfig */
  productTypeConfigId!: string;
  /** FK productTypeConfigId */
  productTypeConfig!: ProductTypeConfig;
  /** FK programViewId */
  programView!: ProgramView;
}

